<template>
  <div>
    <v-row>
      <v-col cols="12" class="text-center">
        <v-btn class="primary" @click="crearDocumento()">Generar La Factura</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  HorizontalPositionAlign,
  HorizontalPositionRelativeFrom,
  Media,
  Packer,
  Paragraph,
  VerticalPositionAlign,
  VerticalPositionRelativeFrom,
  Document,
  TextRun,
  TextWrappingType,
  TextWrappingSide,
  Table,
  TableCell,
  TableRow,
  WidthType,
  AlignmentType,
  Header,
  Footer,
  HeadingLevel
} from "docx";
import { saveAs } from "file-saver";
import { mapState } from "vuex";
export default {
  name: "GenerarDoc",
  computed: {
    ...mapState([
      "logoEmpresa",
      "articulos",
      "condiciones",
      "nombreEmpresa",
      "emailEmpresa",
      "direccionEmpresa",
      "telefonoEmpresa",
      "nombreCliente",
      "emailCliente",
      "direccionCliente",
      "telefonoCliente",
      "totalApagar",
      "numeroFactura",
      "iva",
      "irpf"
    ])
  },
  methods: {
    crearDocumento() {
      console.log("Total articulos: " + this.articulos.length);
      const doc = new Document();
      const imageData = Media.addImage(doc, this.logoEmpresa, 50, 50, {
        floating: {
          horizontalPosition: {
            relative: HorizontalPositionRelativeFrom.PAGE,
            align: HorizontalPositionAlign.RIGHT
          },
          verticalPosition: {
            relative: VerticalPositionRelativeFrom.PAGE,
            align: VerticalPositionAlign.TOP
          },
          wrap: {
            type: TextWrappingType.SQUARE,
            side: TextWrappingSide.BOTH_SIDES
          },

          margins: {
            top: 300,
            bottom: 5
          }
        }
      });

      //Header Tabla de articulos

      let rows = [
        new TableRow({
          tableHeader: true,
          children: [
            new TableCell({
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: "Artículo",
                      bold: true
                    })
                  ]
                })
              ]
            }),
            new TableCell({
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: "Descripción",
                      bold: true
                    })
                  ]
                })
              ]
            }),
            new TableCell({
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: "Cantidad",
                      bold: true
                    })
                  ]
                })
              ]
            }),

            new TableCell({
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: "Precio",
                      bold: true
                    })
                  ]
                })
              ]
            })
          ]
        })
      ];

      // let rows = [];
      console.log(
        "Cantidad del primero articulo : " + this.articulos[0].cantidad
      );
      for (let i = 0; i < this.articulos.length; i++) {
        let children = [];
        children.push(
          new TableCell({
            children: [new Paragraph(this.articulos[i].titulo)]
          }),
          new TableCell({
            children: [new Paragraph(this.articulos[i].descripcion)]
          }),
          new TableCell({
            children: [new Paragraph(" " + this.articulos[i].cantidad)]
          }),
          new TableCell({
            children: [new Paragraph(this.articulos[i].precio)]
          })
        );
        rows.push(
          new TableRow({
            children
          })
        );
      }

      const table2 = new Table({
        width: {
          size: 80,
          type: WidthType.AUTO
        },
        alignment: AlignmentType.CENTER,
        rows
      });
      console.log("this.direccionEmpresa: " + this.direccionEmpresa);
      doc.addSection({
        properties: {},
        headers: {
          default: new Header({
            children: [
              new Paragraph(
                this.nombreEmpresa +
                  " | Email: " +
                  this.emailEmpresa +
                  " | Dirección: " +
                  this.direccionEmpresa +
                  " | Tel: " +
                  this.telefonoEmpresa
              )
            ]
          })
        },
        footers: {
          default: new Footer({
            children: [
              new Paragraph(
                this.nombreEmpresa +
                  " | Email: " +
                  this.emailEmpresa +
                  " | Dirección: " +
                  this.direccionEmpresa +
                  " | Tel: " +
                  this.telefonoEmpresa
              )
            ]
          })
        },
        children: [
          new Paragraph({
            text: "Numero de la factura: "+ this.numeroFactura,
            heading: HeadingLevel.HEADING_4,
            bold: true,
             spacing: {
              before: 200,
              after: 200
            },
            alignment:AlignmentType.CENTER,
            bottom: {
              color: "yellow",
              space: 1,
              value: "single",
              size: 6
            }
          }),
          new Paragraph({
            text: "Datos del cliente",
            heading: HeadingLevel.HEADING_1,
            bold: true,
            bottom: {
              color: "yellow",
              space: 1,
              value: "single",
              size: 6
            }
          }),
          new Paragraph({
            spacing: {
              before: 100
            },
            children: [
              new TextRun("Nombre del cliente: " + this.nombreCliente)
            ],
            bullet: {
              level: 0 // How deep you want the bullet to me
            }
          }),
          new Paragraph({
            children: [new TextRun("Email del cliente: " + this.emailCliente)],
            bullet: {
              level: 0 // How deep you want the bullet to me
            }
          }),
          new Paragraph({
            children: [
              new TextRun("Direccion del cliente: " + this.direccionCliente)
            ],
            bullet: {
              level: 0 // How deep you want the bullet to me
            }
          }),
          new Paragraph({
            children: [
              new TextRun("Teleono del cliente: " + this.telefonoCliente)
            ],
            bullet: {
              level: 0 // How deep you want the bullet to me
            }
          }),
          new Paragraph({
            text: "Artículos",
            spacing: {
              before: 500,
              after: 100
            },
            heading: HeadingLevel.HEADING_1,
            bold: true,
            bottom: {
              color: "yellow",
              space: 1,
              value: "single",
              size: 6
            }
          }),
          table2,
          new Paragraph(imageData),
          new Paragraph({
            text: "TOTAL A PAGAR: " +  this.totalApagar + " €",
            heading: HeadingLevel.HEADING_3,
            bold: true,
            alignment:AlignmentType.RIGHT,
            bottom: {
              color: "yellow",
              space: 1,
              value: "single",
              size: 6
            }
          }),
          new Paragraph({
            text: "IVA: " + this.iva + "%",
            heading: HeadingLevel.HEADING_3,
            bold: true,
            alignment:AlignmentType.RIGHT,
            bottom: {
              color: "yellow",
              space: 1,
              value: "single",
              size: 6
            }
          }),
          
          new Paragraph({
            text: "IRPF: " + this.irpf + "%",
            heading: HeadingLevel.HEADING_3,
            bold: true,
            alignment:AlignmentType.RIGHT,
            bottom: {
              color: "yellow",
              space: 1,
              value: "single",
              size: 6
            }
          }),
          new Paragraph({
            text: "Terminos & Condiciones ",
            heading: HeadingLevel.HEADING_4,
            bold: true,
             spacing: {
              before: 200,
              after: 200
            },
            alignment:AlignmentType.CENTER,
            bottom: {
              color: "yellow",
              space: 1,
              value: "single",
              size: 6
            }
          }),
          new Paragraph({
             spacing: {
              before: 100
            },
            children: [
              new TextRun(this.condiciones)
            ],
          })
        ]
      });

      Packer.toBlob(doc).then(blob => {
        console.log(blob);
        saveAs(blob, "example.docx");
        console.log("Document created successfully");
      });
    }
  }
};
</script>